// ============================================================================
// OPTIMIZED FIREBASE CONFIGURATION - PERFORMANCE ENHANCED
// frontend/src/services/firebase.ts
// ============================================================================

import { initializeApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getFunctions, Functions } from 'firebase/functions';
import { getStorage, FirebaseStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyC_cwJ2lBqsDMzWmGIlcBqyBb2BqP3I6aA",
  authDomain: "face-authentication-app-44ddb.firebaseapp.com",
  projectId: "face-authentication-app-44ddb",
  storageBucket: "face-authentication-app-44ddb.firebasestorage.app",
  messagingSenderId: "541867932129",
  appId: "1:541867932129:android:ed73e3859b053c1555faa0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);
export const functions: Functions = getFunctions(app, 'us-central1');

// Export app
export { app };
export default app;

// Cloud Functions configuration
export const CLOUD_FUNCTIONS_CONFIG = {
  region: 'us-central1',
  timeout: 60000,
  endpoints: {
    getAttendanceData: 'getAttendanceData',
    getEmployeeList: 'getEmployeeList', 
    getAttendanceStats: 'getAttendanceStats',
    healthCheck: 'healthCheck'
  }
};

// Test Cloud Functions connectivity
export const testCloudFunctionsConnection = async (): Promise<boolean> => {
  try {
    const { httpsCallable } = await import('firebase/functions');
    const healthCheck = httpsCallable(functions, 'healthCheck');
    await healthCheck({});
    return true;
  } catch {
    return false;
  }
};

// Test Firebase Storage connectivity
export const testStorageConnection = async (): Promise<boolean> => {
  try {
    const { ref, listAll } = await import('firebase/storage');
    const storageRef = ref(storage, 'documents');
    await listAll(storageRef);
    return true;
  } catch { 
    return false;
  }
};